/*
 * Copyright (c) Nexign, JSC, 2020-2023.
 */
/**
 * Internationalization constants for Settings component
 *
 * @author Aleksandr Perkhunov
 * @author Anton Panasenko
 * @author Yakov Gushchin
 * @author Evgeniy Naumov
 * @author Ilya Baranchikov
 * @version 1.26.0
 * @since 1.3.0
 */

import {
    IPageSettingsAutoReportsTableTranslation,
    IPageSettingsAutoReportsTitleTranslation,
    IPageSettingsTranslation,
} from '@modules/internationalization/types/pages/pageSettings';
import { ESettingsAutoReportsField } from '@pages/PageSettings/components/SettingsAutoReports/components/SettingsAutoReportsTable/settingsAutoReportsTableTypes';
import { ESettingsStatisticsField } from '@pages/PageSettings/components/SettingsStatistics/components/SettingsStatisticsTable/settingsStatisticsTableTypes';

export const initTranslationPageSettingsAutoReportsTable: IPageSettingsAutoReportsTableTranslation = {
    [ESettingsAutoReportsField.DESCRIPTION]: '',
    [ESettingsAutoReportsField.ORDER_ATTR_TYPE]: '',
    [ESettingsAutoReportsField.PERIOD_TYPE]: '',
    [ESettingsAutoReportsField.REPORT_FORMAT]: '',
    [ESettingsAutoReportsField.REPORT_NAME]: '',
    [ESettingsAutoReportsField.START_TIME]: '',
    modalRemoveMessage: '',
};

export const initTranslationPageSettingsAutoReportsTitle: IPageSettingsAutoReportsTitleTranslation = {
    dropFilters: '',
    header: '',
};

export const initTranslationPageSettings: IPageSettingsTranslation = {
    title: {
        label: '',
    },
    settingsAutoReports: {
        table: initTranslationPageSettingsAutoReportsTable,
        title: initTranslationPageSettingsAutoReportsTitle,
    },
    settingsLabels: {
        title: '',
    },
    settingsPositions: {
        title: '',
        labelEditor: {
            apply: '',
            btnCreate: '',
            btnImport: '',
            close: '',
            createLabel: '',
            createPlaceholder: '',
            noSearchMatcher: '',
            removeModal: {
                buttonCancel: '',
                buttonOk: '',
                text: '',
                title: '',
            },
            searchPlaceholder: '',
            selectAll: '',
            title: '',
        },
    },
    settingsStatistics: {
        table: {
            [ESettingsStatisticsField.DATE]: '',
            [ESettingsStatisticsField.IP_ADDRESS]: '',
        },
        title: {
            dropFilters: '',
            header: '',
        },
    },
    settingsNotifications: {
        title: '',
        form: {
            labels: {
                showNotifications: '',
                showNews: '',
                showNotificationsOrders: '',
                showNotificationsInquiries: '',
                showNotificationsEdo: '',
                showNotificationsCashback: '',
            },
            controls: {
                submit: '',
            },
        },
        modal: {
            success: '',
            error: '',
        },
    },
    sideMenuItemNames: {
        autoreports: '',
        labels: '',
        positions: '',
        profile: '',
        statistics: '',
        notifications: '',
    },
    profile: {
        preferredLK: {
            header: '',
            preferred: {
                b2b: '',
                soho: '',
            },
        },
        contacts: {
            emailLabel: '',
            emailNotify: '',
            emailPlaceholder: '',
            header: '',
            phoneLabel: '',
            phoneNotify: '',
            phonePlaceholder: '',
        },
        hints: {
            enable: '',
            header: '',
        },
        onboarding: {
            enable: '',
        },
        password: {
            header: '',
            labelCurrent: '',
            labelNew: '',
            labelNewRepeat: '',
            link: '',
            modalTitle: '',
            placeholder: '',
            subheader: '',
        },
        question: {
            header: '',
            labelAnswer: '',
            labelCurrent: '',
            labelNew: '',
            link: '',
            modalTitle: '',
            placeholderAnswer: '',
            placeholderNew: '',
        },
        errorCodes: {},
        submit: '',
        submitMessage: {
            common: '',
            password: '',
            question: '',
        },
        cancel: '',
    },
};
